<template>
<v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
        <v-btn color="primary" text v-on="on">
            Show details
        </v-btn>
    </template>
    <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Chart Details</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-data-table :headers="headers" :items="results" hide-actions>
                <template v-slot:items="props">
                    <td v-for="(column, index) in props.item" v-bind:key="index" class="text-right">{{ column }}</td>
                </template>
                <template v-slot:footer>
                    <th>Total</th>
                    <th v-for="(total, index) in totals" v-bind:key="index">{{ total }}</th>
                </template>
            </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>
<script>
export default {

    props: {
        data: Object,
    },

    created: function () {

        // Retrieve headers from the datasets
        this.headers = this.data.datasets.map(function (item) {
            return {
                sortable: true,
                text: item.label,
                value: item.label.toLowerCase()
            };
        });
        // First header is the Label
        this.headers.unshift({
            text: "Label",
            value: "label"
        });

        let data = this.data;
        let headers = this.headers;
        let length = data.datasets.length;
        let totals = new Array(length)
            .fill(0);

        // Map datasets to table rows and compute totals
        this.results = this.data.labels.map(function (date, index) {
            let result = {};
            result['label'] = date;
            for(var i = 0; i < length; i++) {
                let value = data.datasets[i].data[index]
                result[headers[i + 1].value] = value;
                totals[i] += parseFloat(value);
            }
            return result;
        });
        this.totals = totals;
    },

    data() {
        return {
            dialog: false,
            headers: [],
            results: [],
            totals: []
        }
    }
}
</script>
